/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react';
import { Summary as OrderSummary, StepName } from '|/app/services';
import * as Summary from '|/app/steps/order-summary/order-summary-components.styles';
import DeliveryAddressDateTimeSection from '|/app/steps/order-summary/sections/delivery-details-section/delivery-address-date-time-section';
import { MarketplaceText } from '|/app/steps/order-summary/sections/delivery-details-section/delivery-details-section.styles';
import numberWithCommas from '|/helpers/number-with-commas';
import useOrderSummaryVm from '|/helpers/use-order-summary';
import SummaryContext from '../../../../summary-context';
import useNavigateToStep from '../../../use-navigate-to-step';

const defaultProps = {
  summary: {} as OrderSummary
};

const DeliveryDetailsSection = ({ summary } = defaultProps) => {
  const { setShowSummary } = useContext(SummaryContext);
  const navigateToStep = useNavigateToStep();
  const {
    hasTransferMethod: showEdit,
    isPickup,
    isDelivery,
    hasScheduledDate,
    vehicleYear: year,
    vehicleMake: make,
    vehicleModel: model,
    vehicleTrim: trim,
    vehicleOdometer: odometer,
    engineDescription,
    isMarketplaceVehicle
  } = useOrderSummaryVm(summary);

  return (
    <Summary.Section>
      <Summary.Heading>
        {!hasScheduledDate && 'Order Details'}
        {hasScheduledDate && isPickup && 'Pick-Up Details'}
        {hasScheduledDate && isDelivery && 'Delivery Details'}
      </Summary.Heading>
      <Summary.Box>
        {isMarketplaceVehicle && <MarketplaceText>Partner</MarketplaceText>}
        <Summary.BoxLabel>
          {year} {make} {model}
        </Summary.BoxLabel>
        <Summary.BoxText blueDark>{trim}</Summary.BoxText>
        <Summary.BoxText blueDark>{engineDescription}</Summary.BoxText>
        {odometer !== null && (
          <Summary.BoxText blueDark>
            {numberWithCommas(odometer)} miles
          </Summary.BoxText>
        )}
      </Summary.Box>
      <DeliveryAddressDateTimeSection summary={summary} />
      {showEdit && (
        <Summary.EditButton
          onClick={() => {
            setShowSummary(false);
            navigateToStep(StepName.PickupDelivery);
          }}
          data-analytics-id="pp_order_summary_edit_pickup_delivery"
        >
          Edit {isDelivery ? 'Delivery' : isPickup ? 'Pick-Up' : null} Details
        </Summary.EditButton>
      )}
    </Summary.Section>
  );
};

export default DeliveryDetailsSection;
